/**
 * Проверяет наличие свойства в объекте или его прототипе.
 *
 * @param obj Объект, в котором ищем свойство.
 * @param key Название свойства, которое проверяем.
 * @returns Истина, если свойство есть
 */
export function hasProperty(obj, key) {
    return key in obj;
}
